const key = Symbol('SegmentedControlKey');

export default key;
